import { constants } from '../config';

const initialState = {
  show: false,
};

export default function setShowNotAllowedToBuyReducer(state = initialState, action) {
  switch (action.type) {
    case constants.SHOW_NOT_ALLOWED_TO_BUY: {
      return {
        ...state,
        show: action.show,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
